<template>
  <div class="new-process-step">
    <b-form @submit="alert('sdf')">
        <b-form-group horizontal label-class="text-sm-left" id="input-group-step_number" label="Step number" label-for="input-step_number" description="">
            <b-form-input id="input-step_number" type="text" v-model="form.step_number" required placeholder="1">
            </b-form-input>
        </b-form-group>
        <b-form-group horizontal label-class="text-sm-left" id="input-group-description" label="Process description" label-for="input-description" description="">
            <b-form-input id="input-description" type="text" v-model="form.description" required placeholder="">
            </b-form-input>
        </b-form-group>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
    }
  },
  props: ['form', 'submit_handler'],
  created () {
      
  },
  watch: {
      
  },
  methods: {
  }
}
</script>
